(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-progress-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-herbary-cart-progress]');
    if (!root) return;

    var message = root.querySelector('[data-cart-progress-message]');
    var track = root.querySelector('[data-cart-progress-track]');
    var threshold = Number(root.dataset.threshold || 5000);
    var hideWhenEmpty = root.dataset.hideEmpty === 'true';
    var announcementSection = root.closest('.shopify-section');

    if (announcementSection && announcementSection.previousElementSibling) {
      announcementSection = announcementSection.previousElementSibling;
    } else {
      announcementSection = null;
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }

      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2
      }).format(cents / 100);
    }

    function render(cart) {
      var total = Number(cart && cart.total_price ? cart.total_price : 0);
      var itemCount = Number(cart && cart.item_count ? cart.item_count : 0);
      var remaining = threshold - total;
      var progress = Math.min(Math.max(total / threshold * 100, 0), 100);
      var isEmpty = itemCount === 0;

      root.classList.toggle('is-empty', hideWhenEmpty && isEmpty);
      track.style.setProperty('--cart-progress', progress + '%');

      if (announcementSection) {
        announcementSection.hidden = !isEmpty;
      }

      if (isEmpty && hideWhenEmpty) {
        message.textContent = '';
      } else if (remaining > 0) {
        message.textContent = "You're " + formatMoney(remaining) + ' away from free UK delivery.';
      } else {
        message.textContent = "You've unlocked free UK delivery.";
      }
    }

    function refresh() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (cart) {
          if (cart) render(cart);
        })
        .catch(function () {});
    }

    document.addEventListener('cart:updated', refresh);
    document.addEventListener('cart:update', refresh);
    document.addEventListener('cart:refresh', refresh);
    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest('cart-items, cart-drawer, form[action*="/cart"]')) {
        window.setTimeout(refresh, 350);
      }
    });
    document.addEventListener('submit', function (event) {
      if (event.target && event.target.matches('form[action*="/cart/add"]')) {
        window.setTimeout(refresh, 900);
      }
    });

    refresh();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
